import { render, staticRenderFns } from "./accommodationsBanner.vue?vue&type=template&id=f4c399a6&scoped=true"
import script from "./accommodationsBanner.vue?vue&type=script&lang=js"
export * from "./accommodationsBanner.vue?vue&type=script&lang=js"
import style0 from "./accommodationsBanner.vue?vue&type=style&index=0&id=f4c399a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c399a6",
  null
  
)

export default component.exports